/**
 * Uninest/Karmabooking
 *
 * Copyright (c) 2020 Karmabunny
 */

import '@/polyfills';
import Vue from 'vue';

import App from '@/app/Uninest.vue';
import router from '@/router/uninest';
import * as kbconfig from '@/config/uninest';

import store from '@/store';
import * as VueGoogleMaps from '@/gmaps-install';
import * as Sentry from "@sentry/vue";
import API, { tr } from '@/api';
import { getISODate, propertyIcon, propertyImage, propertyMapIcon } from '@/utils';
import Icon from '@/components/Icon';
import Modal from '@/components/ModalComponent.vue';

import { getFormatter, format } from '@/money';
import { DateTime, Settings } from 'luxon';

Settings.defaultLocale = navigator.language;

Vue.config.productionTip = false;

// Google maps.
Vue.use(VueGoogleMaps, {
    key: kbconfig.GOOGLE_MAP_KEY,
    libraries: ['places'],
    language: window.__translations.lang,
});

// Bug tracking.
Sentry.init({
    Vue,
    dsn: "https://bab884db233640c298a133200adeb06e@o4505366428975104.ingest.sentry.io/4505587080626176",
});

// Globally available mixin.
// Put all your utilities and whatever in here.
Vue.mixin({
    components: {
        Icon,
        Modal,
    },
    methods: {
        tr,
        format,
        propertyIcon,
        propertyImage,
        propertyMapIcon,
    },
    computed: {
        siteHandle() { return window.__config.site; },
        kbconfig() { return kbconfig; },
        isSearchDirty() { return store.state.dirty_search; },
        isComplete() { return store.state.complete; },
        isSearching() { return store.state.searching; },
    },
    filters: {
        dateString: (value?: Date | null) => {
            return DateTime.fromJSDate(value!).toLocaleString();
        },
        moneyFormat: format,
    },
});

// Mount the app.
// See 'App.vue'
const app = new Vue({
    router,
    store,
    data() {
        return {
            lang: window.__translations.lang,
        }
    },
    render(h) {
        // This forces vue to re-render everything whenever the language is changed.
        return h(App, { key: this.$data.lang });
    },
    mounted() {
        this.$store.dispatch('refresh');
    }
});

app.$mount('#app');
